import { Component, inject, input, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import {
  ITransactionHeader,
  ITransactionLineItem,
  ITransactionPaymentRecord
} from 'src/app/EBMSuite/models/transaction.model';
import { IOrganization } from 'src/app/common/model/organization.model';
import { FileService } from 'src/app/common/services/file/file.service';
import { OrganizationService } from 'src/app/common/services/organization/organization.service';
import { UtilService } from 'src/app/common/services/util/util.service';
import { ProjectConstants } from 'src/assets/constants/project.constants';

@Component({
  selector: 'app-receipts-print-view',
  templateUrl: './receipts-print-view.component.html',
  styleUrls: ['./receipts-print-view.component.scss']
})
export class ReceiptsPrintViewComponent implements OnInit {
  subscription = new Subscription();
  organization!: IOrganization | null;
  organizationLogo: any;

  projectConstants = ProjectConstants;

  @Input() receiptDetailsHeader!: ITransactionHeader | null;
  @Input() receiptPaymentRecords: ITransactionPaymentRecord[] = [];
  @Input() receiptLineItems!: ITransactionLineItem[] | [];
  @Input() receiptType!: string | '';

  sign = input<string>();
  stamp = input<string>();

  organizationService = inject(OrganizationService);
  fileService = inject(FileService);
  sanitizer = inject(DomSanitizer);
  utilService = inject(UtilService);

  ngOnInit(): void {
    this.getOrganization();
  }

  getOrganization(): void {
    this.subscription.add(
      this.organizationService.getCurrentOrganization().subscribe({
        next: (res) => {
          this.organization = res.result.organization;
          const currentOrganizationId = this.organization.currentLogoId;
          this.getOrgImage(currentOrganizationId);
        }
      })
    );
  }
  getOrgImage(fileId: string): void {
    this.subscription.add(
      this.fileService.getImageFileById(fileId).subscribe({
        next: (res) => {
          this.createImageFromBlob(res);
        }
      })
    );
  }

  createImageFromBlob(image: Blob) {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        this.organizationLogo = reader.result;
      },
      false
    );

    if (image) {
      reader.readAsDataURL(image);
    } else {
      this.organizationLogo = null;
    }
  }
}
